function initializeProductSwipers() {
  const productSwipers = document.querySelectorAll(".product-swiper:not(.swiper-initialized)");

  productSwipers.forEach(function (swiperElement) {
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      allowTouchMove: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: swiperElement.querySelector(".swiper-button-next"),
        prevEl: swiperElement.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: swiperElement.querySelector('.swiper-pagination'),
        clickable: true,
      },
      on: {
        slideChange: function () {
          // Prevent navigation to product page when swiping
          const slides = this.slides;
          slides.forEach((slide) => {
            const link = slide.querySelector("a");
            if (link) {
              link.style.pointerEvents = "none";
              setTimeout(() => {
                link.style.pointerEvents = "auto";
              }, 300);
            }
          });
        },
      },
    });

    // Auto-slide to second image on hover
    swiperElement.addEventListener("mouseenter", function () {
      if (swiper.slides.length > 1 && swiper.realIndex === 0) {
        swiper.slideTo(1);
      }
    });

    // Reset to first slide when mouse leaves
    swiperElement.addEventListener("mouseleave", function () {
      swiper.slideTo(0);
    });
  });
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", initializeProductSwipers);

// Re-initialize when new content is loaded
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length > 0) {
      initializeProductSwipers();
    }
  });
});

if (document.body) {
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
